import { createContext, FC, ReactNode, useContext, useMemo } from 'react';

// De qual tenant é o rateio que os hooks de faturamento leem e alteram.
//
// Sem provider (tela /faturamento do cliente), o escopo é vazio: os hooks operam
// no tenant corrente do usuário e o preço do plano vem do userInfo. O painel /adm
// envolve a aba de rateio num provider com o tenant selecionado, e os mesmos
// componentes (editor de pesos, formulário de SPE) passam a operar nele — PBI 12501.
export interface IRateioScope {
  tenantId?: number;
  // Preço do plano do tenant em escopo. No /adm vem do tenant listado, não do
  // usuário logado (que é da Coordly).
  planPrice?: number;
}

const RateioScopeContext = createContext<IRateioScope>({});

interface IRateioScopeProvider extends IRateioScope {
  children: ReactNode;
}

export const RateioScopeProvider: FC<IRateioScopeProvider> = ({
  tenantId,
  planPrice,
  children,
}) => {
  const value = useMemo(() => ({ tenantId, planPrice }), [tenantId, planPrice]);

  return (
    <RateioScopeContext.Provider value={value}>
      {children}
    </RateioScopeContext.Provider>
  );
};

export const useRateioScope = (): IRateioScope => useContext(RateioScopeContext);
